<template>
  <div class="wrap talk">
		<header>
			<h1><a href="#" class="logo"></a></h1>
		</header>
		<div class="container">
			<main class="content">
				<article class="certification">
					<section class="txt card-chart">
						<h2>데이터 삭제 진행률 안내</h2>
						<p><span>데이터 삭제</span>진행률 안내입니다.</p>
					</section>
					<section class="chart">
						<!-- <div class="graph-donut" data-percent="80">
							<span class="percent">80</span>
						</div>
						<vue-easy-pie-chart bar-Color='#4299CC' :percent="80">
							<i class="fa-icon fa-icon-email">80</i>
						</vue-easy-pie-chart> -->
						<vue-easy-pie-chart :percent="percent"
											:bar-color="barColor"
											:track-color="trackColor"
											:scale-color="scaleColor"
											:line-cap="lineCap"
											:line-width="lineWidth"
											:scale-length="scaleLength"
											:size="size"
											:rotate="rotate"
											:font-size="fontSize">
						</vue-easy-pie-chart>						
						<div class="chart-txt" v-if="percent === 100">
							데이터 삭제가 완료되었습니다!
						</div>
						<div class="chart-txt" v-else-if="percent >= 70 && percent < 100 ">
							거의 다 되었어요!
						</div>						
						<div class="chart-txt" v-else-if="percent >= 40 && percent < 70 ">
							조금만 더 기다려주세요!
						</div>						
						<div class="chart-txt" v-else>
							데이터 삭제가 진행중이에요.
						</div>																		
					</section>
					<div class="btn-wrap">
						<a href="#" class="btn btn-black">새로고침</a>
					</div>
				</article>
			</main>
		</div>
	</div>
</template>

<script>

import Vue from 'vue'
import AppConfig from '@/config'
import Utils from '@/modules/utils'

import VueEasyPieChart from 'vue-easy-pie-chart'
import 'vue-easy-pie-chart/dist/vue-easy-pie-chart.css'

const $ = window.$

export default {
  name: 'DelPrcsPrgs',
  components: {
	  VueEasyPieChart
  },
  data: () => ({

	AppConfig: AppConfig,
	ordNum : '',

	easing: 'easeOutBounce',
	percent: 0,
	barColor: "#4299CC",
	trackColor: "#f2f2f2",
	scaleColor: "#e1e1e3",
	scaleLength: 0,
	lineCap: "square",
	lineWidth: 30,
	size: 200,
	rotate: 0,
	fontSize: "20px"	
  }),

   watch: {

  },
  computed: {

  },
  mounted() {

	this.ord_num = this.$route.query.ord_num    

	this.delPrgs()

	console.log(this.percent)



  },
  methods: {

    async delPrgs () {

      const params = {
        ordNum : this.$route.query.ordNum 
      }

      console.log('params ==> {}', params)

      const rtn = await Vue.httpClient
        .get('/api/purchase/pcs/mgmt/public/del-prgs', {params} )
        .then(res => {
          if (res.data.status === AppConfig.HTTP_RESPONSE_SUCCESS) {
            if (res.data.result) {

				console.log(res.data.result)

				this.percent = parseInt(res.data.result)

				var myTimeout = setTimeout(this.delPrgs, 5000);

				if( this.percent === 100) {
				 	clearTimeout(myTimeout);
				}

            } else {
              Vue.Alert.alert("매입정보가 없습니다!")  
            }
          } else {
            Vue.Alert.alert("통신 오류 입니다.")
          }
        })	  
	}
  }
}
</script>



// WEBPACK FOOTER //
// src/views/purchase/DelPrcsPrgs.vue